import { useState, useEffect } from "react";
import styles from "./BlacklistFilters.module.scss";

const BlacklistFilters = ({
  filters,
  onFiltersChange,
  loading
}) => {
  const [localSearch, setLocalSearch] = useState("");

  useEffect(() => {
    // Initialize local search from filters
    setLocalSearch(filters.search || "");
  }, [filters.search]);

  useEffect(() => {
    // Debounce search input
    const timeoutId = setTimeout(() => {
      if (localSearch !== filters.search) {
        onFiltersChange({
          ...filters,
          search: localSearch
        });
      }
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [localSearch, filters, onFiltersChange]);

  const handleSearchChange = (e) => {
    setLocalSearch(e.target.value);
  };

  const handleTypeChange = (e) => {
    onFiltersChange({
      ...filters,
      type: e.target.value
    });
  };

  const handleClearFilters = () => {
    setLocalSearch("");
    onFiltersChange({
      type: 'all',
      search: ''
    });
  };

  const hasActiveFilters = filters.search || filters.type !== 'all';

  return (
    <div className={styles.wrapper}>
      <div className={styles.filters}>
        {/* Search Input */}
        <div className={styles.searchContainer}>
          <input
            type="text"
            className={styles.searchInput}
            placeholder="Search by name, email, domain, or reason..."
            value={localSearch}
            onChange={handleSearchChange}
            disabled={loading}
          />
          {localSearch && (
            <button
              className={styles.clearSearchButton}
              onClick={() => setLocalSearch("")}
              type="button"
              title="Clear search"
            >
              ×
            </button>
          )}
        </div>

        {/* Type Filter */}
        <div className={styles.selectContainer}>
          <select
            className={styles.typeSelect}
            value={filters.type}
            onChange={handleTypeChange}
            disabled={loading}
          >
            <option value="all">All Types</option>
            <option value="contact">👤 Contacts Only</option>
            <option value="domain">🌐 Domains Only</option>
          </select>
        </div>

        {/* Clear Filters Button */}
        {hasActiveFilters && (
          <button
            className={styles.clearFiltersButton}
            onClick={handleClearFilters}
            disabled={loading}
            type="button"
          >
            Clear Filters
          </button>
        )}
      </div>

    </div>
  );
};

export default BlacklistFilters;